import store from "../../../../Store/store";
import { Card } from "@sainsburys-tech/luna-card";
import { Container } from "@sainsburys-tech/luna-grid";
import { FC, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { editTablePayload } from "../../../../Redux/Actions/editTableActions";
import FamilyGroupManagementForm from "../Edit-FamilyGroupManagement/familyGroupManagementForm";
import { storeAddPayload } from "../../../../Redux/Actions/popupActions";
import {
  IInitialStateFamilyGroupManagement,
  iInitialStateFamilyGroupManagement,
} from "../../../../Interfaces/IFamilyGroupManagement";
import {
  validateDuplicate,
  validateField,
  validateForm,
} from "./familyGroupManagementValidations";
import { MANAGEMENTFIELDS } from "../../../../Interfaces/IFamilyGroupManagementFormField";

export interface FamilyGroupManagementProps {
  closeModal: () => void;
  isEdit: boolean;
  title: string;
}

const FamilyGroupManagementEdit: FC<FamilyGroupManagementProps> = ({
  closeModal,
  isEdit,
  title,
}) => {
  const [state, setState] = useState<IInitialStateFamilyGroupManagement>(
    iInitialStateFamilyGroupManagement
  );
  const payload = useSelector((state: any) => state.popupReducer);

  useEffect(() => {
    setState(payload);
    if (payload.data) {
      setState(payload.data.editPayload);
    } else {
      setState(iInitialStateFamilyGroupManagement);
    }
  }, [payload]);

  /*Events of form*/
  const handleBlur = (target: any) => {
    const { values, errors } = state;

    const fieldName = target.name || target.id;
    const valid = validateField(
      fieldName,
      values[fieldName as keyof typeof values],
      values
    );
    setState((initialState: IInitialStateFamilyGroupManagement) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        dirty: true,
      };
    });
  };

  const handleChange = (
    target: any,
    familygroup: string,
    productgroup: string,
    isCheckBox: boolean
  ) => {
    setState((initialState: IInitialStateFamilyGroupManagement) => {
      return {
        ...initialState,
        values: {
          ...initialState.values,
          [target.name]: isCheckBox ? target.checked : target.value,
        },
        dirty: true,
        errors: iInitialStateFamilyGroupManagement.errors,
      };
    });
  };

  const handleSubmit = (e: any) => {
    const { values } = state;
    e.preventDefault();
    const valid = validateForm(values);
    setState((initialState: IInitialStateFamilyGroupManagement) => {
      return {
        ...initialState,
        errors: { ...errors, ...valid.errors },
        submitted: valid.result,
      };
    });

    if (!valid.result) {
      setTimeout(scrollToError, 100);
      return;
    }

    validateDuplicate(values, payload).then((response) => {
      if (!response.valid) {
        setState((initialState: IInitialStateFamilyGroupManagement) => {
          return {
            ...initialState,
            errors: { ...errors, ...response.error },
            submitted: response.valid,
          };
        });
        setTimeout(scrollToError, 100);
        return;
      }

      if (isEdit) {
        const editPayload = {
          Id: payload.data.id,
          FamilyGroup: values.FamilyGroup,
          ProductType: values.ProductType,
          LPFamilyGroupMix: values?.LPFamilyGroupMix ? true : false,
          MLPFamilyGroupMix: values?.MLPFamilyGroupMix ? true : false,
          SerialControl: values?.SerialControl
            ? values?.SerialControl
            : iInitialStateFamilyGroupManagement.values.SerialControl,
          SerialInputMask: values?.SerialInputMask,
          StrapTotes: values?.StrapTotes
        };
        store.dispatch(editTablePayload(editPayload));
      } else {
        store.dispatch(
          storeAddPayload({
            addPayload: {
              familyGroup: values.FamilyGroup,
              productType: values.ProductType,
              LPFamilyGroupMix: values?.LPFamilyGroupMix ? true : false,
              MLPFamilyGroupMix: values?.MLPFamilyGroupMix ? true : false,
              SerialControl: values?.SerialControl
                ? values?.SerialControl
                : iInitialStateFamilyGroupManagement.values.SerialControl,
              SerialInputMask: values?.SerialInputMask,
              StrapTotes: values?.StrapTotes
            },
          })
        );
      }

      closeModal();
    });
  };

  const clearAll = (e: any) => {
    setState(iInitialStateFamilyGroupManagement);
  };
  const scrollToError = () => {
    const firstError = document.querySelector(
      ".ln-c-form-group.has-error"
    ) as HTMLElement | null;
    if (firstError) {
      window.scrollTo(0, firstError.offsetTop);
      const inputField = firstError.querySelector(
        "input"
      ) as HTMLElement | null;
      inputField?.focus();
    }
  };
  /*Events of form*/

  const { values, errors, submitted, dirty } = state;

  return (
    <>
      <h4 className="familyGroupModal-heading">{title}</h4>
      <FamilyGroupManagementForm
        values={values}
        onBlur={(event: any) => handleBlur(event.target)}
        onChange={(
          event,
          familygroup: string,
          productType: string,
          isCheckBox: boolean
        ) =>
          handleChange(
            event.target,
            event.label,
            event.value?.desc,
            isCheckBox
          )
        }
        onSubmit={(event: any) => handleSubmit(event)}
        onClearAll={(event: any) => clearAll(event)}
        onCancel={closeModal}
        errors={errors}
        dirty={dirty}
        submitted={submitted}
        isEdit={isEdit}
      />
    </>
  );
};

export default FamilyGroupManagementEdit;
